/**
 * Utilitários de mídia para o módulo de atendimento.
 * Detecta tipo de arquivo e monta payload de mensagem com mídia.
 */

/**
 * Detecta o tipo de mídia a partir do MIME type do arquivo.
 *
 * @param {File|Object|null} file - Objeto com propriedade `type` (MIME)
 * @returns {'imagem'|'video'|'audio'|'documento'}
 */
export function detectMediaType(file) {
  if (!file || !file.type) return 'documento'
  if (file.type.startsWith('image/')) return 'imagem'
  if (file.type.startsWith('video/')) return 'video'
  if (file.type.startsWith('audio/')) return 'audio'
  return 'documento'
}

/**
 * Monta o payload para envio de mensagem com mídia.
 *
 * @param {Object} params
 * @param {string} params.tipo - Tipo da mídia (imagem, video, audio, documento)
 * @param {string} params.caption - Legenda da mídia
 * @param {boolean} params.is_note - Se é nota interna
 * @param {string|null} params.reply_to_message_id - ID da mensagem respondida
 * @param {Object} params.media - Objeto com media_url, media_mime_type, media_filename, media_size_bytes
 * @returns {Object} Payload pronto para enviar via enviarMensagem
 */
export function buildMediaMessagePayload({
  tipo,
  caption,
  is_note,
  reply_to_message_id,
  media,
}) {
  return {
    tipo,
    conteudo: caption || '',
    is_note: is_note || false,
    reply_to_message_id: reply_to_message_id || null,
    media_url: media.media_url,
    media_mime_type: media.media_mime_type,
    media_filename: media.media_filename,
    media_size_bytes: media.media_size_bytes,
  }
}
